<template>
  <div>
    <section>
        <div class="inner row5">
          <article class="loginInner">
            <h1>비밀번호 재설정</h1>
            <div class="aRow5">
              <p>
                비밀번호를 입력해주세요.
              </p>
              <p>
                로그인 후 비밀번호를 바로 변경해주시기 바랍니다.
              </p>
            </div>

            <ValidationObserver v-slot="{ handleSubmit }">
              <form class="aRow5" @submit.prevent="handleSubmit(onClickAuthForResetPassword)">
                <ValidationProvider class="inputBox" name="아이디" rules="required|id" v-slot="{errors}">
                    <label>아이디</label>
                    <input v-model="id" maxlength="20">
                    <span class="notValidationTxt positionFix">{{errors[0]}}</span>
                </ValidationProvider> 
                <ValidationProvider class="inputBox authBtnBox" name="휴대폰 번호" rules="required|mobileTel" v-slot="{errors, valid}">
                  <label>휴대폰 번호</label>
                  <input v-model="phoneNumber" @keypress="eventUtil.onKeyPressForOnlyDigit($event)">
                  <input type="button" value="인증번호 받기" @click="onClickRequestVerifyNumber(valid)">
                  <span class="notValidationTxt positionFix">{{errors[0]}}</span>
                </ValidationProvider>
                <ValidationProvider class="inputBox authBtnBox" name="인증번호" rules="verifyNum" v-slot="{errors, valid}">
                  <label>인증번호 6자리 입력</label>
                  <input v-model="verifyNumber" maxlength="6" @keypress="eventUtil.onKeyPressForOnlyDigit($event)" :placeholder="counterPlaceHolder">
                  <input type="button" value="확인" @click="onClickConfirmVerifyNumber(valid)" :disabled="counter == 0">
                  <span class="notValidationTxt positionFix">{{errors[0]}}</span>
                  <vac ref="verifyNumberCounter" :autoStart="false" :end-time="new Date().getTime() + 180000">
                    <template v-slot:process="{ timeObj }">
                      {{onProcesssVerifyNumberCounter(timeObj)}}
                    </template>
                    <template v-slot:finish>
                      {{onFinishVerifyNumberCounter()}}
                    </template>
                  </vac>
                </ValidationProvider>

                <div class="inputBtnBox">
                  <button class="firstAtagBtn" type="submit"><span class="joinTxt nomargin"><strong>비밀번호 재설정</strong></span></button>
                  <button type="button" @click="$router.go(-1)"><strong>로그인으로 돌아가기</strong></button>
                </div>
              </form>
            </ValidationObserver>
          </article>
        </div>
    </section> 

  </div>   
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions } from 'vuex'
import * as eventUtil from '@/utils/eventUtil'

export default {
  name: 'PWResetAuth',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data(){
    return{
      eventUtil: eventUtil,
      id: '',
      phoneNumber: '',
      checkedPhoneNumber: '', // 인증을 요청한 전화번호
      isVerified: false,      // 전화번호 인증 여부
      verifyNumber: '',       // 인증번호
      counter: 0,             // 인증번호 유효 시간 카운터
      counterPlaceHolder: '', // 인증번호 유효 시간 카운터(출력용)
    }
  },
  methods:{
    ...mapActions('sms', [
      'requestVerifyNumber',
      'confirmVerifyNumber'
    ]),
    ...mapActions('auth',[
      'authForResetPassword'
    ]),
    onClickRequestVerifyNumber(isValidPhoneNumber){
      if(!isValidPhoneNumber || this.phoneNumber === ''){
        this.$alert("알림", "휴대폰번호를 확인해주세요.");
        return
      }
      
      const phoneNumber = this.phoneNumber
      this.isVerified = false

      this.requestVerifyNumber({
        phoneNumber: phoneNumber,
        contents: '[경희대SSK]비밀번호 재설정\r\n전화번호 인증'
      })
      .then((response) => {
        const data = response.data

        if(data.RESULT == 'true'){
          this.checkedPhoneNumber = phoneNumber // 인증번호를 요청한 전화번호 저장
          this.$refs.verifyNumberCounter.startCountdown('restart')
          this.$alert("알림", "인증번호를 발송했습니다.(유효시간 3분) <br>"+
          "인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
          "이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다.");
        }
        else{
          this.checkedPhoneNumber = '' // 인증번호를 요청한 전화번호 초기화
          this.$refs.verifyNumberCounter.finishCountdown()
          if(data.ERROR_CODE == 'SUCCESSIVE_REQUEST' || data.ERROR_CODE == 'BLOCKED'){
            this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
          }
          else{
            this.$alert("알림", "인증번호 요청을 실패했습니다.");
          }
        }
      })
      .catch(()=>{
        this.checkedPhoneNumber = '' // 인증번호를 요청한 전화번호 초기화
        this.$refs.verifyNumberCounter.finishCountdown()
        this.$alert("알림", "인증번호 요청을 실패했습니다.");
      })
    },
    onClickConfirmVerifyNumber(isValidVerifyNumber){
      if(!isValidVerifyNumber || this.verifyNumber === ''){
        return
      }

      this.confirmVerifyNumber({
        phoneNumber: this.checkedPhoneNumber,
        verifyNum: this.verifyNumber
      })
      .then((response) =>{
        const data = response.data

        if(data.RESULT == "true"){
          this.isVerified = true
          this.$refs.verifyNumberCounter.finishCountdown()
          this.$alert("알림", "인증되었습니다.");
        }
        else{
          this.isVerified = false
          this.$alert("알림", "유효하지 않은 인증번호 입니다.");
        }
      })
      .catch(() => {
        this.isVerified = false
        this.$alert("알림", "요청 실패");
      })
    },
    onProcesssVerifyNumberCounter(timeObj){
      this.counter = (timeObj.m ) * 60 + timeObj.s
      this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`
    },
    onFinishVerifyNumberCounter(){
      this.counter = 0
      this.counterPlaceHolder = ''
    },
    onClickAuthForResetPassword(){
      if(!(this.isVerified && this.phoneNumber === this.checkedPhoneNumber)){
        this.$alert("알림", "전화번호를 인증해주세요.");
        return
      }

      const id = this.id
      const phoneNumber = this.phoneNumber

      this.authForResetPassword({
        id: id,
        phoneNumber: phoneNumber
      })
      .then(response => {
        var data = response.data

        if(data.RESULT == true){
          this.$router.replace({
            name: 'PWReset', 
            params: { 
              userIdx: data.USER_IDX,
              phoneNumber: phoneNumber,
              id: id
            }
          })  
        }
      })
      .catch(() => {
        this.$alert('알림', '회원 정보를 찾을 수 없습니다.')
      })
    }
  }
}
</script>

<style scoped>
    .loginInner > h1 {
        color: #9E1915;
    }
</style>